import React, { Component } from "react";
import { Row, Col, Grid } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import Paper from "material-ui-next/Paper";
import { TextField, StyledButton, Loadable } from "components/support";

import { enumWhitelabel } from "assets";

import { brands } from "assets";
import Icon from "material-ui-next/Icon";
import style from "./style";

class SignUpView extends Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.presenter.onSubmitted();
    this.props.presenter.onFormSubmit();
  };

  render() {
    const { presenter, viewModel, className } = this.props;
    const { success, loading, form } = viewModel;
    const { fields, errors } = form;
    const {
      companyName,
      name,
      email,
      password,
      confirmPassword,
      phone
    } = fields;

    return (
      <div className={`${className} full-width`}>
        <div className="main-div">
          <Grid fluid>
            <Row middle="xs">
              <Col xs={12}>
                {success && (
                  <div>
                    <script type="text/javascript">
                      var google_conversion_id = 870543250; var
                      google_conversion_language = "en"; var
                      google_conversion_format = "3"; var
                      google_conversion_color = "ffffff"; var
                      google_conversion_label = "lOi5CIDYvnMQkt-NnwM"; var
                      google_remarketing_only = false;
                    </script>
                    <script
                      type="text/javascript"
                      src="//www.googleadservices.com/pagead/conversion.js"
                    />
                    <noscript>
                      <div className="noscript-div">
                        <img
                          height="1"
                          width="1"
                          className="noscript-img"
                          alt=""
                          src="//www.googleadservices.com/pagead/conversion/870543250/?label=lOi5CIDYvnMQkt-NnwM&amp;guid=ON&amp;script=0"
                        />
                      </div>
                    </noscript>
                    <script type="text/javascript">
                      var google_conversion_id = 856625606; var
                      google_conversion_language = "en"; var
                      google_conversion_format = "3"; var
                      google_conversion_color = "ffffff"; var
                      google_conversion_label = "GyGtCOmCxXUQxqO8mAM"; var
                      google_remarketing_only = false;
                    </script>
                    <script
                      type="text/javascript"
                      src="//www.googleadservices.com/pagead/conversion.js"
                    />
                    <noscript>
                      <div className="noscript-div">
                        <img
                          height="1"
                          width="1"
                          className="noscript-img"
                          alt=""
                          src="//www.googleadservices.com/pagead/conversion/856625606/?label=GyGtCOmCxXUQxqO8mAM&amp;guid=ON&amp;script=0"
                        />
                      </div>
                    </noscript>
                  </div>
                )}
                <div className="text-center mv-sm">
                  <img
                    src={brands.png.primary}
                    height="80"
                    alt="PDVend"
                    className="pdvend-logo"
                  />
                </div>
                <Row center="xs">
                  <Col xs={12} sm={9} md={5} lg={4}>
                    <Paper elevation={3} className="p-sm">
                      <Loadable loading={loading}>
                        <Typography type="headline">
                          <StyledButton
                            onClick={() => presenter.redirectToLogin()}
                            circular
                            className="btn-back"
                            leftIcon={
                              <Icon className="btn-back-icon">
                                keyboard_backspace
                              </Icon>
                            }
                            flat
                          />
                          Cadastre-se já
                        </Typography>
                        <form id="signup" onSubmit={this.handleSubmit}>
                          <Row>
                            <Col xs={12}>
                              <TextField
                                fullWidth
                                value={companyName}
                                onChange={(event, value) =>
                                  presenter.handleFieldChange(
                                    "companyName",
                                    value
                                  )
                                }
                                label="Nome da sua empresa"
                                errorText={errors.companyName || ""}
                              />
                            </Col>
                            <Col xs={12}>
                              <TextField
                                fullWidth
                                value={name}
                                onChange={(event, value) =>
                                  presenter.handleFieldChange("name", value)
                                }
                                label="Seu nome"
                                errorText={errors.name || ""}
                              />
                            </Col>
                            <Col xs={12}>
                              <TextField
                                type="text"
                                maskPattern={[
                                  "(",
                                  /\d/,
                                  /\d/,
                                  ")",
                                  " ",
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  "-",
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  /\d/
                                ]}
                                fullWidth
                                value={phone}
                                onChange={(event, value) =>
                                  presenter.handleFieldChange(
                                    "phone",
                                    value.replace(/\D/g, "")
                                  )
                                }
                                label="Seu telefone"
                                errorText={errors.phone || ""}
                              />
                            </Col>
                            <Col xs={12}>
                              <TextField
                                type="text"
                                fullWidth
                                value={email}
                                onChange={(event, value) =>
                                  presenter.handleFieldChange("email", value)
                                }
                                label={`E-mail para acessar a ${enumWhitelabel.formLabels}`}
                                errorText={errors.email || ""}
                              />
                            </Col>
                            <Col xs={12}>
                              <TextField
                                type="password"
                                fullWidth
                                value={password}
                                onChange={(event, value) =>
                                  presenter.handleFieldChange("password", value)
                                }
                                label={`Senha para acessar a ${enumWhitelabel.formLabels}`}
                                errorText={errors.password || ""}
                              />
                            </Col>
                            <Col xs={12}>
                              <TextField
                                type="password"
                                fullWidth
                                value={confirmPassword}
                                onChange={(event, value) =>
                                  presenter.handleFieldChange(
                                    "confirmPassword",
                                    value
                                  )
                                }
                                label="Confirmação da Senha"
                                errorText={errors.confirmPassword || ""}
                              />
                            </Col>
                            <Col xs={12} className="text-center">
                              <div className="mv-md">
                                <span>
                                  Para utilizar o Caixa de Loja baixe nosso
                                  aplicativo na Play Store:
                                </span>
                                <div>
                                  <a
                                    href={enumWhitelabel.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      style={{ height: "70px" }}
                                      alt="Disponível no Google Play"
                                      src="https://play.google.com/intl/en_us/badges/images/generic/pt-br_badge_web_generic.png"
                                    />
                                  </a>
                                </div>
                              </div>
                            </Col>
                            <Col xs={12}>
                              <StyledButton
                                className="btn-submit"
                                primary
                                type="submit"
                                label="Cadastre seu login e senha"
                              />
                            </Col>
                          </Row>
                        </form>
                        <script type="text/javascript">
                          var __ss_noform = __ss_noform || [];
                          __ss_noform.push(['baseURI',
                          'https://app-3QNB567ETW.marketingautomation.services/webforms/receivePostback/MzawMDEztDA1AwA/']);
                          __ss_noform.push(['form', 'signup',
                          'e0cf7c6c-b83b-4054-99ac-3a42b5f2c2b2']);
                        </script>
                        <script
                          type="text/javascript"
                          src="https://koi-3QNB567ETW.marketingautomation.services/client/noform.js?ver=1.24"
                        />
                      </Loadable>
                    </Paper>
                    <Row>
                      <Col xs={12}>
                        <p className="support-contact">
                          <span>
                            Se tiver algum problema, fique à vontade para entrar
                            em contato conosco:{" "}
                          </span>
                          <a
                            href={`mailto:suporte@pdvend.com.br`}
                            className="support-contact-email"
                          >{`suporte@pdvend.com.br`}</a>
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default style(SignUpView);



// WEBPACK FOOTER //
// ./src/components/app/sign-up/view.jsx